<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-6">
        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>

        <div class="box">
          <admin-box-item title="쿠폰 기본 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="할인 부담 유형" v-if="isAdmin">
                  <lp-radio :val="value.burden_type"
                            value_name="value"
                            label_name="label"
                            :data="burdenTypeArr"
                            @onSelect="val=>selectType(val,'burden_type')"></lp-radio>
                  <span class="desc1" v-if="value.burden_type===0">할인 차감된 비용에 대해 플랫폼이 전부 부담합니다.</span>
                  <span class="desc1" v-else-if="value.burden_type===1">할인 차감된 비용에 대해 쿠폰 사용을 수락한 파트너와 공동으로 부담합니다.</span>
                </admin-form-item>
                <admin-form-item label="혜택 유형">
                  <lp-radio :val="value.benefits_type"
                            value_name="value"
                            label_name="label"
                            :data="benefitTypeArr"
                            @onSelect="val=>selectType(val,'benefits_type')"></lp-radio>
                  <span class="desc1" v-if="value.benefits_type===0">상품마다 쿠폰을 적용할 수 있습니다.</span>
                  <span class="desc1" v-else-if="value.benefits_type===1">주문금액에 쿠폰을 적용할 수 있습니다.</span>
                  <span class="desc1" v-else>상품에 적용된 배송비를 할인합니다.</span>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="쿠폰명">
                  <input class="input"
                         :value="value.name"
                         @input="e => value.name = e.target.value"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="쿠폰 설명">
                  <input class="input"
                         :value="value.desc"
                         @input="e => value.desc = e.target.value"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="쿠폰번호" v-if="value.num">
                  {{ value.num }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="할인 금액">
                  <lp-radio :val.sync="value.discount_type"
                            value_name="value"
                            label_name="label"
                            :showInput="true"
                            @onEdit="res => inputDiscount(res)"
                            :data="discountTypeArr"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="value.burden_type===1">
                <admin-form-item label="할인 부담 금액 설정" v-if="value.discount_type===0">
                  <div class="flex">
                    <div style="width:50%">
                      <div style="color:#989898;margin-bottom:6px">플랫폼 부담</div>
                      <input class="input full has-text-right"
                             v-model="value.admin_discount_rate"
                             placeholder="0"
                             @input="e =>setPrice(e, 'admin', 'discount_rate')"
                             type="number">
                    </div>
                    <div style="width:50%">
                      <div style="color:#989898;margin-bottom:6px">파트너 부담</div>
                      <input class="input full has-text-right"
                             v-model="value.partner_discount_rate"
                             placeholder="0"
                             @input="e =>setPrice(e, 'partner', 'discount_rate')"
                             type="number" style="margin-left:4px">
                    </div>
                  </div>
                  <div class="desc1">플랫폼과 파트너의 할인 부담율을 입력하세요. 두 개의 합이 총 할인율과 일치해야 합니다. </div>
                </admin-form-item>
                <admin-form-item label="할인 부담 금액 설정" v-if="value.discount_type===1">
                  <div class="flex">
                    <div style="width:50%">
                      <div style="color:#989898;margin-bottom:6px">플랫폼 부담</div>
                      <input class="input full has-text-right"
                             v-model="value.admin_discount_price"
                             placeholder="0"
                             @input="e =>setPrice(e, 'admin', 'discount_price')"
                             type="number">
                    </div>
                    <div style="width:50%">
                      <div style="color:#989898;margin-bottom:6px">파트너 부담</div>
                      <input class="input full has-text-right"
                             v-model="value.partner_discount_price"
                             placeholder="0"
                             @input="e =>setPrice(e, 'partner', 'discount_price')"
                             type="number" style="margin-left:4px">
                    </div>
                  </div>
                  <div class="desc1">플랫폼과 파트너의 할인 부담 금액을 입력하세요. 두 개의 합이 금액 할인 총액과 일치해야 합니다.</div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box">
          <admin-box-item title="발행 설정">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="발행 상태">
                  <lp-radio :val="value.activate"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'발행중',value:true},{label:'발행중지',value:false}]"
                            @onSelect="val=>selectType(val,'activate')"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="발행 유형">
                  <lp-radio :val="value.publish_type"
                            value_name="value"
                            label_name="label"
                            :data="couponTypeArr"
                            @onSelect="val=>selectType(val,'publish_type')"></lp-radio>
                </admin-form-item>
                <span class="desc1" v-if="value.publish_type===0">쿠폰을 등록한 다음 발행 버튼을 눌러 쿠폰을 받을 회원을 직접 선택합니다.</span>
                <span class="desc1" v-else-if="value.publish_type===1">설정한 조건을 충족한 회원에게 자동 발급됩니다.</span>
                <span class="desc1" v-else-if="value.publish_type===2">회원이 직접 다운로드할 수 있는 쿠폰을 발행합니다.</span>

              </div>
              <div class="column is-full flex" v-if="value.publish_type===1">
                <div>
                  <span class="select">
                    <select v-model="value.auto_publish">
                      <option v-for="(item,idx) in autoPublishTypeArr" :key="'auto-publish-'+idx"
                              :value="item.value">{{ item.label }}</option>
                    </select>
                  </span>
                </div>
                <div style="margin-left:4px" v-if="value.auto_publish===2">
                  <input class="input full has-text-right"
                         v-model="value.order_price"
                         placehoder="주문 금액 기준 입력"
                         @input="e =>value.order_price=e.target.value"
                         type="number">
                </div>
                <div style="margin-left:4px" v-if="value.auto_publish===3">
                  <input class="input full has-text-right"
                         v-model="value.limit"
                         placehoder="누적 이용 횟수 충족 시"
                         @input="e =>value.limit=e.target.value"
                         type="number">
                </div>
              </div>
              <div class="column is-full" v-else-if="value.publish_type===2">
                <admin-form-item label="발행 수 제한">
                  <lp-radio :val="value.enable_download_limit"
                            value_name="value"
                            label_name="label"
                            :data="[{label: '제한없음', value:false},{label: '제한', value:true}]"
                            @onSelect="val=>selectType(val,'enable_download_limit')"></lp-radio>
                  <div class="flex-align"
                       style="margin-top:12px"
                       v-if="value.enable_download_limit===true">
                    <div>선착순 최대</div>
                    <input class="input"
                           type="number"
                           placeholder="0"
                           v-model="value.download_limit_count"
                           :min="1"
                           @input="e=>setNumber(e, 'download_limit_count', 10)" style="width:100px;margin:0 6px">
                    <span>장</span>
                  </div>
                </admin-form-item>
                <admin-form-item label="1인당 다운로드 가능한 횟수" style="margin-top:12px">
                  <lp-radio :val="value.person_download_limit_type"
                            value_name="value"
                            label_name="label"
                            :data="[{label: '최대 1회', value:0},{label: '횟수 설정', value:1}]"
                            @onSelect="val=>selectType(val,'person_download_limit_type')"></lp-radio>
                  <span class="desc1" v-if="value.person_download_limit_type===0">1명의 회원이 최대 1장까지 다운받을 수 있습니다.</span>
                  <span class="desc1" v-else-if="value.person_download_limit_type===1">1명의 회원이 다운로드 받을 수 있는 쿠폰의 최대 수량을 입력합니다.</span>
                  <div class="flex-align"
                       style="margin-top:12px"
                       v-if="value.person_download_limit_type===1">
                    <div>최대</div>
                    <input class="input"
                           type="number"
                           placeholder="1"
                           v-model="value.person_download_limit_count"
                           @input="e=>setNumber(e, 'person_download_limit_count', 10)"
                           :min="1"
                           style="width:100px;margin:0 6px">
                    <span>장</span>
                  </div>
                </admin-form-item>
                <admin-form-item label="다운로드 가능 기간*">
                  <div class="flex" style="flex-wrap:wrap">
                    <div style="align-items: center;">
                      <admin-date-picker
                        type="date"
                        :data="value.download_start"
                        placeholderDate="시작일 선택"
                        @setDate="val=>this.value.download_start=val"></admin-date-picker>
                    </div>
                    <div class="lp-dating">&#126;</div>
                    <div style="align-items: center;">
                      <admin-date-picker
                        type="date"
                        placeholderDate="종료일 선택"
                        :data="value.download_end"
                        @setDate="val=>this.value.download_end=val"></admin-date-picker>
                    </div>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box">
          <admin-box-item title="쿠폰 사용 조건 설정">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="사용 가능일 제한">
                  <lp-radio :val="value.limit_type"
                            value_name="value"
                            label_name="label"
                            :data="limitTypeArr"
                            :block="true"
                            @onSelect="val=>selectType(val,'limit_type')"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column" v-if="value.limit_type===0">
                <div class="flex-align">
                  <div style="width:115px">쿠폰 받은 날로 부터</div>
                  <input class="input full has-text-right"
                         style="width:100px;margin:0 6px"
                         v-model="value.few_day"
                         @input="e =>value.few_day=e.target.value"
                         type="number">
                  <div style="width:102px">일 이내 사용 가능</div>
                </div>
              </div>
              <div class="column is-12" v-if="value.limit_type===1">
                <admin-date-picker
                  placeholderDate="종료일 선택"
                  :data="value.end_date"
                  :not_before="moment().format('YYYY-MM-DD')"
                  @setDate="val=>value.end_date=val"></admin-date-picker>
              </div>

              <div class="column is-12" v-if="value.limit_type===2">
                <div class="flex" style="flex-wrap:wrap">
                  <div style="align-items: center;">
                    <admin-date-picker
                      type="datetime"
                      placeholderDate="시작일 선택"
                      :data="value.coupon_start"
                      :not_before="moment().format('YYYY-MM-DD HH:MM')"
                      @setDate="date => value.coupon_start = date"></admin-date-picker>
                  </div>
                  <div class="lp-dating">&#126;</div>
                  <div style="align-items: center;">
                    <admin-date-picker
                      type="datetime"
                      placeholderDate="종료일 선택"
                      :data="value.coupon_end"
                      :not_before="moment().format('YYYY-MM-DD HH:MM')"
                      @setDate="date => value.coupon_end = date"></admin-date-picker>
                  </div>
                </div>
              </div>
              <div class="column is-12">
                <admin-form-item :label="minimumPriceLabel">
                  <div class="flex-align">
                    <input class="input full has-text-right"
                           style="width:320px"
                           v-model="value.condition"
                           @input="e => setNumber(e, 'condition', 10)"
                           type="number" maxlength="10">
                    <span style="margin-left:8px">원</span>
                  </div>
                  <div class="desc1" v-if="value.benefits_type===0 || value.benefits_type===2">상품에 대한 최종 결제 예정 금액이 설정한 금액 이상일 때 사용 가능합니다.</div>
                  <div class="desc1" v-else-if="value.benefits_type===1">주문 합계에 대한 결제 예정 금액이 설정한 금액 이상일 때 사용 가능합니다.</div>
                </admin-form-item>
              </div>
              <div class="column is-12" v-if="value.benefits_type!==1">
                <admin-form-item label="쿠폰 사용 가능한 상품 범위 설정">
                  <lp-radio :val="value.available_range"
                            value_name="value"
                            label_name="label"
                            :data="availableRangeTypeArr"
                            @onSelect="val=>selectType(val,'available_range')"></lp-radio>
                </admin-form-item>
              </div>
              <!-- 특정 상품 -->
              <div class="column is-12" v-if="value.available_range===1">
                <button class="button is-primary"
                        @click="$modal.show('productListModal')">상품 검색
                </button>
                <button class="button"
                        style="margin-left:8px"
                        @click="deleteProductItem" v-if="productTable.length>0">전체 삭제
                </button>
                <div style="overflow-x: auto" v-if="productTable.length>0">
                  <div style="min-width:800px">
                    <table class="table">
                      <thead>
                      <tr>
                        <th style="width: 40px;">id</th>
                        <th style="width: 40px;">이미지</th>
                        <th style="width: 40px;">상품명</th>
                        <th style="width: 40px;">카테고리</th>
                        <th style="width: 40px;">상품 가격</th>
                        <th style="width: 120px;">파트너</th>
                        <th style="width: 40px;">삭제</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(pi,idx) in productTable" :key="'product-item'+idx" class="lp-row many-field-tr">
                        <td>{{ pi.product.id }}</td>
                        <td style="padding: 6px 12px;">
                          <div style="text-align: center;display: inline-block"
                               :style="thumbImgField(pi.product.first_img)" v-if="pi.product.first_img"></div>
                        </td>
                        <td>{{ pi.product.name }}</td>
                        <td>{{ pi.product.category }}</td>
                        <td>
                          <div v-if="pi.price.price_type===0">{{ pi.price.price | currency }}</div>
                          <div v-else>{{ pi.price.price_text }}</div>
                        </td>
                        <td style="width:60px">
                          <div v-if="pi.product.is_super_visor">
                            <span v-for="(partner, p_idx) in pi.product.partner_name_list" :key="`partner-${p_idx}`">
                            {{ partner }}<span v-if="p_idx<pi.product.partner_name_list.length-1">,</span></span>
                          </div>
                          <div v-else>{{ pi.product.partner?pi.product.partner.name:'' }}</div>
                        </td>
                        <td>
                          <button class="button is-danger" @click="deleteProductItem(idx)">삭제</button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- 카테고리 -->
              <div class="column is-12" v-if="value.available_range===2">
                <admin-form-item label="카테고리" :isHeaderBlock="true" desc="* 카테고리를 설정하지 않는 경우, 모든 상품에서 이 옵션 템플릿을 사용할 수 있습니다.">
                  <div class="flex-align wrap">
                    <lp-adm-drop-input ref="adminput_prod1"
                                       :data.sync="catArr1"
                                       @onSelect="res=>clickCategory(res.value, 'cat1')"
                                       placeholder="1차 카테고리"
                                       width="160px"
                                       listAlign="center"
                                       style="display:inline-block; margin-right:4px;margin-bottom:4px"></lp-adm-drop-input>

                    <lp-adm-drop-input ref="adminput_prod2"
                                       :data.sync="cat2"
                                       @onSelect="res=>clickCategory(res.value, 'cat2')"
                                       placeholder="2차 카테고리"
                                       width="160px"
                                       listAlign="center"
                                       style="display:inline-block; margin-right:4px;margin-bottom:4px"></lp-adm-drop-input>

                    <lp-adm-drop-input ref="adminput_prod3"
                                       :data.sync="cat3"
                                       @onSelect="res=>clickCategory(res.value, 'cat3')"
                                       placeholder="3차 카테고리"
                                       width="160px"
                                       listAlign="center"
                                       style="display:inline-block; margin-right:4px;margin-bottom:4px"></lp-adm-drop-input>
                    <button class="button is-primary" style="margin-bottom:4px" @click="addCategory">+추가</button>
                  </div>

                  <!-- 추가된 카테고리 -->
                  <div v-for="(cat, cat_idx) in value.categorys" :key="`cat-${cat_idx}`">
                    <div class="flex-align" style="padding: 8px 0">
                      <div class="cat-name">{{ categoryName(cat) }}</div>
                      <i class="material-icons cat-close unselect" @click="deleteCategory(cat_idx)">close</i>
                    </div>
                  </div>
                </admin-form-item>
              </div>
              <!-- 특정 파트너 -->
              <div class="column is-12" v-if="value.available_range===3">
                <button class="button is-primary"
                        @click="$modal.show('partnerListModal')">파트너 검색
                </button>
                <button class="button"
                        style="margin-left:8px"
                        @click="deletePartnerItem" v-if="partnerTable.length>0">전체 삭제
                </button>
                <div style="overflow-x: auto" v-if="partnerTable.length>0">
                  <div style="min-width:600px">
                    <table class="table">
                      <tbody>
                      <tr class="tr-whole-border">
                        <th>id</th>
                        <th>파트너</th>
                        <th>이미지</th>
                        <th>등록한 상품 수</th>
                        <th>파트너 삭제</th>
                      </tr>

                      <tr v-for="(pi,idx) in partnerTable" :key="'partner-item'+idx" class="lp-row many-field-tr">
                        <td>{{ pi.id }}</td>
                        <td>{{ pi.name }}</td>
                        <td>
                          <div style="text-align: center;display: inline-block"
                               :style="thumbImgField(pi.first_img)" v-if="pi.img"></div>
                        </td>
                        <td class="unselect" style="text-decoration: underline" @click="selectProductCount(pi.name)">{{ pi.product_count }}</td>
                        <td><button class="button is-danger" @click="deletePartnerItem(idx)">삭제</button></td>
                      </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

    <modal name="productListModal" :adaptive="true" :width="900" height="auto" class="modal-style">
      <product-list @productItems="productItems" page="exhibition" :selectedItems="value.product_list" :coupon="true"
                    style="zoom: 0.85"></product-list>
    </modal>
    <modal name="partnerListModal" :adaptive="true" :width="900" height="auto" class="modal-style">
      <partner-list @tableItems="partnerItems" page="exhibition" :selectedItems="value.partner_list"
                    style="zoom: 0.85"></partner-list>
    </modal>
  </div>
</template>

<script>
  import LpRadio from "../../module/common/LpRadio";
  import AdminBoxItem from "../../module/admin/AdminBoxItem";
  import AdminFormItem from "../../module/admin/AdminFormItem";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import ProductList from "../product/ProductList";
  import PartnerList from "../partner/PartnerList";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";

  export default {
    components: {
      LpAdmDropInput,
      PartnerList,
      ProductList,
      LpCheckBool,
      AdminFormItem,
      AdminBoxItem,
      LpRadio
    },
    name: "coupon-create",
    data() {
      return {
        partner_id: 0,
        value: {
          name: '',
          num: '',
          discount_price: 0,
          discount_type: 0,
          discount_rate: 0,
          quantity: 0,
          limit_type: 3, // 제한 방법 (몇일 이내, 날짜지정)
          few_day: 3, // 몇일 이내
          end_date: '',
          type: 'not_auto',
          condition: 0,
          publish_type: 0, // 발행 유형(0: 수동발행, 1: 조건부 자동 발행)
          auto_publish: 0, // 조건부 자동 발행(0: 회원가입, 1: 첫구매, 2: 누적 주문 금액 충족 시),
          order_price: 0, // 누적 주문 금액,
          burden_type: 0, // 할인 부담 유형(0: 플랫폼 전체, 1: 플랫폼+파트너 공동, 2: 파트너)
          desc: '',
          admin_discount_price: 0, //플랫폼 부담 금액
          partner_discount_price: 0, // 파트너 부담 금액
          admin_discount_rate: 0, // 플랫폼 부담 비율
          partner_discount_rate: 0, // 파트너 부담 비율
          activate: true,
          coupon_end: "",
          coupon_start: "",
          enable_limit: false,
          limit: 0,
          benefits_type: 0,
          enable_download_limit: false,
          download_limit_count: 1,
          person_download_limit_type: 0,
          person_download_limit_count: 1,
          download_start: '',
          download_end: '',
          available_range: 0,
          product_list: [],
          partner_list: [],
          categorys: []
        },
        // 발행 유형
        couponTypeArr: [
          {label: '수동 발행', value: 0},
          {label: '조건부 자동 발행', value: 1},
          {label: '다운로드 쿠폰 발행', value: 2},
          // {label: '시리얼 쿠폰 발행', value: 3}
        ],
        // 할인 부담 유형
        burdenTypeArr: [
          {label: '플랫폼 전체 부담', value: 0},
          {label: '플랫폼+파트너 공동 부담', value: 1}
        ],
        limitTypeArr: [
          {label: '없음', value: 3},
          {label: '쿠폰 받은 날로부터 사용 가능한 일수 지정', value: 0},
          {label: '사용종료일 지정', value: 1},
          {label: '시작일 ~ 종료일 지정', value: 2}
        ],
        autoPublishTypeArr: [
          {label: '회원가입', value: 0},
          {label: '첫 구매', value: 1},
          {label: '누적 주문 금액 충족 시', value: 2},
          {label: '누적 이용 횟수 충족 시', value: 3}
        ],
        productTable: [],
        partnerTable: [],
        catArr1: [],
        catArr2: [],
        catArr3: [],
        cat2: [],
        cat3: [],
        selectedCategory: {
          category1_id: '',
          category2_id: '',
          category3_id: '',
        }
      }
    },
    watch: {
      'value.limit'(n) {
        if (parseInt(n) <= 0) {
          this.value.limit = 0;
        }
      },
      'value.publish_type'(n) {
        // 조건부 발행
        if (n === 1) {
          this.limitTypeArr = [
            {label: '없음', value: 3},
            {label: '쿠폰 받은 날로부터 사용 가능한 일수 지정', value: 0}
          ]
          // this.value.limit_type = 0;
        } else {
          this.limitTypeArr = [
            {label: '없음', value: 3},
            {label: '쿠폰 받은 날로부터 사용 가능한 일수 지정', value: 0},
            {label: '사용종료일 지정', value: 1},
            {label: '시작일 ~ 종료일 지정', value: 2}
          ]
          // this.value.limit_type = 0;
        }
      },
      'selectedCategory.category1_id'(n){
        this.cat2 = this.get_cat(this.catArr2, n);
      },
      'selectedCategory.category2_id'(n){
        this.cat3 = this.get_cat(this.catArr3, n)
      },
    },
    created() {
      this.getData();
      this.getCats();
      this.initPartner();
      if (!this.isAdmin) {
        this.autoPublishTypeArr.splice(0, 1);
      }
    },
    computed: {
      availableRangeTypeArr() {
        let result = [
          {label: '전체 상품', value: 0},
          {label: '특정 상품', value: 1},
          {label: '특정 카테고리', value: 2},
          {label: '특정 파트너', value: 3},
        ]
        if(!this.isAdmin) {
          result = [
            {label: '전체 상품', value: 0},
            {label: '특정 상품', value: 1},
            {label: '특정 카테고리', value: 2},
          ]
        }
        return result;
      },
      benefitTypeArr() {
        let result = [{label:'상품 금액 할인', value:0},{label:'주문 금액 할인', value:1},{label:'배송료 할인', value:2}];
        if(!this.isAdmin) {
          result = [{label:'상품 금액 할인', value:0},{label:'배송료 할인', value:2}];
        }
        return result;
      },
      minimumPriceLabel() {
        let label = '';
        switch (this.value.benefits_type) {
          case 0:
            label = '최소 상품 구매 금액 제한';
            break;
          case 1:
            label = '최소 주문 금액 제한';
            break;
          case 2:
            label = '최소 상품 구매 금액 제한';
            break;
        }
        return label;
      },
      // 할인 방법
      discountTypeArr () {
        let result = [
          {label:'할인율', value:0, num: this.value.discount_rate, unit:'%'},
          {label:'금액 할인', value:1, num: this.value.discount_price, unit:'원'}];
        if(this.value.benefits_type===2) {
          result = [
            {label:'금액 할인', value:1, num: this.value.discount_price, unit:'원'}
          ]
          this.value.discount_type = 1;
        }
        return result;
      }
    },
    methods: {
      initPartner() {
        if (!this.isAdmin) {
          // 파트너 자체 부담
          this.value.burden_type = 2;
          this.partner_id = this.$store.getters.partner.partner_id;
        }
      },
      getData() {
        let product_fields = '?fields=id,first_img,name,category,price.price_text,price.price,price.price_type,partner.name'
        if (this.$route.query.id) {
          this.$axios.get(this.getUrl(`coupon/${this.$route.query.id}`)).then(res => {
            if(res.status===200) {
              this.value = res.data;
              let productTable = [];
              let partnerTable = [];
              this.value.product_list.forEach(product_id => {
                //`user/0/mapping/product/${product_id}${product_fields}`
                this.$axios.get(`admin/product/${product_id}`).then(res=>{
                  productTable.push(res.data);
                })
              })
              this.value.partner_list.forEach(partner_id=>{
                this.$axios.get(`user/0/mapping/partner/${partner_id}`).then(res=>{
                  partnerTable.push(res.data);
                })
              })
              this.productTable = productTable;
              this.partnerTable = partnerTable;
            }
          })
        }
      },
      // 쿠폰 유형 선택
      selectType(value, type) {
        this.value[type] = value;
        if(type==='benefits_type') {
          this.value.available_range = 0;
        }
      },
      // radio edit반환값
      inputDiscount(res) {
        console.log(res)
        if (res.text === '' || res.text === 0) res.text = 0;
        if (res.value === 0) {
          let discount_rate = parseInt(res.text);
          console.log(discount_rate)
          if (discount_rate > 100) discount_rate = 100;
          this.value.discount_rate = discount_rate;
        } else {
          this.value.discount_price = parseInt(res.text);
        }
      },
      setPrice(e, type1, type2) {
        let value = parseInt(e.target.value);
        if (value < 0) value = 0;
        let full_type = type1 + '_' + type2
        this.value[full_type] = value;

        let user_type = 'admin';
        if (type1 === 'admin') user_type = 'partner';
        if (this.value[type2] < this.value[full_type]) {
          this.value[full_type] = this.value[type2];
          this.value[`${user_type}_${type2}`] = 0;
        } else {
          this.value[`${user_type}_${type2}`] = this.value[type2] - this.value[full_type];
        }
      },
      setNumber(e, type, max_length) {
        if (e.target.value.length > max_length) this.value[type] = e.target.value.substr(0, max_length);
        else this.value[type] = e.target.value;
      },
      saveData() {
        if(this.value.limit_type===1) {
          if(!this.value.end_date) {
            this.toast('종료일 날짜를 선택하세요.');
            return;
          }
        }
        if(this.value.limit_type===2) {
          if(this.value.coupon_start) {
            if(!this.value.coupon_end) {
              this.toast('종료일 날짜를 선택하세요.');
              return;
            }
          }
          else if(this.value.coupon_end) {
            if(!this.value.coupon_start) {
              this.toast('시작일 날짜를 선택하세요.');
              return;
            }
          }
          else if(!this.value.coupon_start && !this.value.coupon_end) {
            this.toast('시작일 ~ 종료일 날짜를 선택하세요.');
            return;
          }
        }
        if (this.value.name === '') {
          this.toast('쿠폰명을 입력하세요.');
          return;
        }
        // 할인율 유효성 체크
        if (this.value.burden_type === 1 && this.value.discount_type === 0) {
          if (this.value.discount_rate !== this.value.admin_discount_rate + this.value.partner_discount_rate) {
            this.toast('할인율 합을 입력해주세요.');
            return;
          }
        }
        // 할인금액 유효성 체크
        else if (this.value.burden_type === 1 && this.value.discount_type === 1) {
          if (this.value.discount_price !== this.value.admin_discount_price + this.value.partner_discount_price) {
            this.toast('할인금액 합을 입력해주세요.');
            return;
          }
        }
        // 발행 유형이 다운로드 쿠폰일 경우
        if(this.value.publish_type===2) {
          if(this.value.download_start && !this.value.download_end) {
            this.toast('다운로드 가능 기간 종료일을 선택해주세요.');
            return;
          }
          else if(this.value.download_end && !this.value.download_start) {
            this.toast('다운로드 가능 기간 시작일을 선택해주세요.');
            return;
          }
          else if(!this.value.download_start && !this.value.download_start) {
            this.toast('다운로드 가능 기간을 선택해주세요.')
            return;
          }
        }
        let value = this.cloneItem(this.value);
        if (!this.isAdmin) {
          value.partner_id = this.partner_id;
        }
        if (this.$route.query.id) {
          this.$axios.patch(this.getUrl(`coupon/${this.$route.query.id}`), value).then(res => {
            if (res.status === 200) {
              this.toast('쿠폰이 수정되었습니다.');
              this.$router.replace(this.getPath('coupon'));
            }
          })
        } else {
          this.$axios.post(this.getUrl(`coupon`), value).then(res => {
            if (res.status === 200) {
              this.saveServiceGuide('point_coupon');
              this.toast('쿠폰이 등록되었습니다.');
              this.$router.replace(this.getPath('coupon'));
            }
          })
        }
      },
      deletePartnerItem(idx) {
        if (idx >= 0) {
          removeIndex(this.partnerTable, idx);
          removeIndex(this.value.partner_list, idx);
        } else {
          this.partnerTable = [];
          this.value.partner_list = [];
        }
      },
      deleteProductItem(idx) {
        if (idx >= 0) {
          removeIndex(this.productTable, idx);
          removeIndex(this.value.product_list, idx);
        } else {
          this.productTable = [];
          this.value.product_list = [];
        }
      },
      // 상품 정보 리스트
      productItems(res) {
        for (let i = 0; i < res.id_list.length; i++) {
          if (this.value.product_list.includes(res.id_list[i]) === false) {
            this.value.product_list.push(res.id_list[i]);
            this.productTable.push({
              product: res.productItems[i],
              price: res.productItems[i].price
            });
            res.productItems[i].partner_name_list = res.productItems[i].partner_list;
          }
        }
        this.$modal.hide('productListModal');
      },
      // 파트너 정보 리스트
      partnerItems(res) {
        for (let i = 0; i < res.id_list.length; i++) {
          if (this.value.partner_list.includes(res.id_list[i]) === false) {
            this.value.partner_list.push(res.id_list[i]);
            this.partnerTable.push(res.tableItems[i]);
          }
        }
        this.$modal.hide('partnerListModal');
      },
      clickCategory (value, type) {
        if (type === 'cat1') {
          this.selectedCategory.category1_id = value;
          this.selectedCategory.category2_id = '';
          this.selectedCategory.category3_id = '';
          this.$refs.adminput_prod2.selectedLabel = '';
          this.$refs.adminput_prod3.selectedLabel = '';
        } else if (type === 'cat2') {
          this.selectedCategory.category2_id = value;
          this.selectedCategory.category3_id = '';
          this.$refs.adminput_prod3.selectedLabel = '';
        } else if (type === 'cat3') {
          this.selectedCategory.category3_id = value;
        }
      },
      addCategory() {
        let is_same_category = false;
        this.value.categorys.forEach(item=>{
          if(item.category1_id===this.selectedCategory.category1_id &&
            item.category2_id===this.selectedCategory.category2_id &&
            item.category3_id===this.selectedCategory.category3_id) {
            is_same_category = true;
          }
        })
        if(is_same_category) {
          return;
        }

        if(this.selectedCategory.category1_id) {
          let data = {
            category1_id: this.selectedCategory.category1_id,
            category2_id: this.selectedCategory.category2_id,
            category3_id: this.selectedCategory.category3_id,
          }
          this.value.categorys.push(data);
        }
        else {
          this.toast('카테고리를 선택하고 추가하세요.');
        }
      },
      deleteCategory (cat_idx) {
        let cat = this.value.categorys[cat_idx];
        if(cat.id) {
          //  삭제 api 호출
          let url = `product/coupon/${this.value.id}/coupon_category/${cat.id}`;
          this.$axios.delete(this.getUrl(url)).then(res => {
            if(res.status===200) {
              removeIndex(this.value.categorys, cat_idx);
            }
          })
        }
        else {
          removeIndex(this.value.categorys, cat_idx);
        }
      },
      categoryName(cat) {
        let name = '';
        if(cat.category1_id) {
          name += find(this.catArr1, 'value', cat.category1_id).label;
        }
        if(cat.category2_id) {
          name += ' > ' + find(this.catArr2, 'value', cat.category2_id).label;
        }
        if(cat.category3_id) {
          name += ' > ' + find(this.catArr3, 'value', cat.category3_id).label;
        }
        return name;
      },
      getCats(){
        // 카테고리 가져오기
        this.$axios.get(this.getUrl('category'))
          .then(res => {

            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let i = 0; i < res.data.length; i++) {
              let cat = res.data[i];
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name, packages: cat.packages});

              for (let j = 0; j < cat.child.length; j++) {
                let cat2 = cat.child[j];
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let k = 0; k < cat2.child.length; k++) {
                  let cat3 = cat2.child[k];
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }
            this.cat2 = this.get_cat(this.catArr2, this.selectedCategory.category1_id);
            this.cat3 = this.get_cat(this.catArr3, this.selectedCategory.category2_id);
          });
      },
      selectProductCount(partner_name) {
        window.open(this.getPath(`product?search_keyword=${partner_name}`))
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'

  .desc1
    color #9A9A9A
    font-size 12px
  .cat-name
    color $primary

  .cat-close
    color white
    background-color $primary
    border-radius 50%
    font-size 14px
    margin-left 5px
</style>
